import * as React from "react";
import MappingInteractionTab from "./MappingInteractionTab";
import "./MappingInteraction.scss";

const MappingInteraction = () => {
  return <MappingInteractionTab />;
};

export default MappingInteraction;
